import React from "react";
import { Select, SelectTrigger, SelectValue, SelectContent, SelectItem } from "../ui/select";
import styles from "./SectionHeader.module.css";

const SectionHeader = ({ 
  title,
  Icon,               // React component from lucide-react
  iconBgColor = "#dcf1e4", 
  iconColor = "#31ac5e", // color of the icon
  dropdownOptions = [],
  selectedValue,
  onDropdownChange,
  dropdownPlaceholder = "All Accounts",
  organizationOptions = [],
  selectedOrganization,
  onOrganizationChange,
  locationOptions = [],
  selectedLocation,
  onLocationChange,
  dateOptions = [],
  selectedDate,
  onDateChange
}) => {
  return (
    <div className={styles.sectionHeader}>
      <h2 className={styles.title}>
        {Icon && (
          <span
            className={styles.iconWrapper}
            style={{ backgroundColor: iconBgColor }}
          >
            <Icon color={iconColor} size={20} />
          </span>
        )}
        {title}
      </h2>

      {/* <div className={styles.dropdownsContainer}>
        {dropdownOptions.length > 0 && (
          <div className={styles.dropdownGroup}>
            <label className={styles.dropdownLabel}>Account</label>
            <Select value={selectedValue || ""} onValueChange={onDropdownChange}>
              <SelectTrigger className={styles.selectTrigger}>
                <SelectValue placeholder={dropdownPlaceholder} />
              </SelectTrigger>
              <SelectContent>
                {dropdownOptions.map((option) => (
                  <SelectItem key={option.value} value={option.value}>
                    {option.label}
                  </SelectItem>
                ))}
              </SelectContent>
            </Select>
          </div>
        )}

        {organizationOptions.length > 0 && (
          <div className={styles.dropdownGroup}>
            <label className={styles.dropdownLabel}>Organization</label>
            <Select value={selectedOrganization || ""} onValueChange={onOrganizationChange}>
              <SelectTrigger className={styles.selectTrigger}>
                <SelectValue placeholder="All Organizations" />
              </SelectTrigger>
              <SelectContent>
                {organizationOptions.map((option) => (
                  <SelectItem key={option.value} value={option.value}>
                    {option.label}
                  </SelectItem>
                ))}
              </SelectContent>
            </Select>
          </div>
        )}

        {locationOptions.length > 0 && (
          <div className={styles.dropdownGroup}>
            <label className={styles.dropdownLabel}>Location</label>
            <Select value={selectedLocation || ""} onValueChange={onLocationChange}>
              <SelectTrigger className={styles.selectTrigger}>
                <SelectValue placeholder="All Locations" />
              </SelectTrigger>
              <SelectContent>
                {locationOptions.map((option) => (
                  <SelectItem key={option.value} value={option.value}>
                    {option.label}
                  </SelectItem>
                ))}
              </SelectContent>
            </Select>
          </div>
        )}

        {dateOptions.length > 0 && (
          <div className={styles.dropdownGroup}>
            <label className={styles.dropdownLabel}>Date</label>
            <Select value={selectedDate || ""} onValueChange={onDateChange}>
              <SelectTrigger className={styles.selectTrigger}>
                <SelectValue placeholder="All Dates" />
              </SelectTrigger>
              <SelectContent>
                {dateOptions.map((option) => (
                  <SelectItem key={option.value} value={option.value}>
                    {option.label}
                  </SelectItem>
                ))}
              </SelectContent>
            </Select>
          </div>
        )}
      </div> */}
    </div>
  );
};

export default SectionHeader;
